import React from 'react';
import axios from 'axios';
import { withTranslation } from "react-i18next";
import { ThemeProvider, Modal } from '@workboard/wobo-ui';

class KpiMarketPlaceExternalLoginPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = { iframeWidth: '500px', iframeHeight: '375px', jwt: ''};
        this.handleMessage = this.handleMessage.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    async componentDidMount() {
        const response = await axios.post(`${wbConfig.baseUrl}/integration/generateInstantToken?overrideExisting=false`);

        this.setState({ jwt: response.data.instantToken });

        window.addEventListener('message', this.handleMessage);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handleMessage);
    }

    createMessagePayload(func) {
        return woboClients.createMessage(func, { jwt: this.state.jwt });
    }

    handleClose() {
        this.props.closePopup();
    }

    handleCancel() {
        this.props.cancelPopup();
    }

    handleMessage(event) {
        const frame = document.getElementById('wobo-external-app-container');
        // once message is received, we need to send the message back to child
        console.log(`Sending message to origin: ${event.origin}`);
        switch (event.data.func) {
            case "initialize":
                frame.contentWindow.postMessage(this.createMessagePayload(event.data.func), event.origin);
                break;
            case "cancelled":
                this.handleCancel();
                break;
            case "iframe-resize":
                const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
                const height = Math.min(vh - 120, parseInt(event.data.args.child.iframeSize.height));
                this.setState({ iframeWidth: event.data.args.child.iframeSize.width, iframeHeight: height + 'px' });
                break;
            case "user-connection-checked":
                this.handleClose();
                break;
            default:
                console.log('Unknown event: %o', event);
        }
    }
    
    render() {
        return (
            <ThemeProvider>
                <Modal isOpen={true} submitOnly={true} className="kpi-market-place-external-login-modal" title="Connection" onDismiss={this.handleCancel} actions={() => null}>
                    <div className="kpi-market-place-external-login-content" style={{width: this.state.iframeWidth, height: this.state.iframeHeight }}>
                        {this.state.jwt && <iframe id="wobo-external-app-container" src={`${wbConfig.kpiUrl}/client/external/login/${this.props.kpiType}`}  style={{width: 'inherit', height:"inherit" }} />}
                    </div>
                </Modal>
            </ThemeProvider>
        );
    }
};

export default withTranslation()(KpiMarketPlaceExternalLoginPopup);
